import { render, staticRenderFns } from "./video_list.vue?vue&type=template&id=4882acf8"
import script from "./video_list.vue?vue&type=script&lang=js"
export * from "./video_list.vue?vue&type=script&lang=js"
import style0 from "./video_list.vue?vue&type=style&index=0&id=4882acf8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports